import $ from 'jquery';
import Isotope from 'isotope-layout';
import {Fancybox} from "@fancyapps/ui";

$(document).ready(function() {
    $('.galleryIsotopeListing').each(function (index, element) {
        const listingSelector = '.listing';
        const listSelector = listingSelector + '__list';
        const itemSelector = listingSelector + '__item';
        const $listing = $(element);
        const $filters = $listing.find(listingSelector + '__filters');
        const $filterDropdown = $filters.find('select');
        const $filterButtons = $filters.find('a');
        const $items = $listing.find(itemSelector);
        const $pagination = $listing.find(listingSelector + '__pagination');
        const step = 12;
        let visibleItemsNum = step;
        let filterValue = '*';
        let matchCounter = 0;
        let uri = location.href;
        let isotope = null;

        function resetItemsHeight() {
            $items.css('height', '');
            $items.each(function (index, element) {
                const $item = $(element);
                $item.css('height', $item.outerHeight());
            });
        }

        function showMoreItems() {
            visibleItemsNum = visibleItemsNum + step;
            render();
        }

        function alignItemsHeight() {
            let itemsInRow = [];
            let rowHeight = 0;
            const filteredElements = isotope.getFilteredItemElements();
            resetItemsHeight();
            filteredElements.forEach(function (element, index) {
                const $item = $(element);
                if ( index > 0 ) {
                    if ( $item.offset().top === $(filteredElements[index-1]).offset().top ) {
                        itemsInRow.push( $item );
                        rowHeight = $item.outerHeight() > rowHeight ? $item.outerHeight() : rowHeight;
                    }
                    else {
                        itemsInRow.forEach(function ($item) {
                            $item.css('height', rowHeight);
                        });
                        itemsInRow = [ $item ];
                        rowHeight = $item.outerHeight();
                    }
                } else {
                    itemsInRow.push( $item );
                    rowHeight = $item.outerHeight();
                }
                if ( index === filteredElements.length - 1 ) {
                    itemsInRow.forEach(function ($item) {
                        $item.css('height', rowHeight);
                    });
                }
            });
        }

        function isotopeFilter() {
            const match = filterValue === '*' || $(this).hasClass( filterValue );
            if ( match ) {
                matchCounter++;
            }
            return match && matchCounter <= visibleItemsNum;
        }

        function handleFilters() {
            const hashValue = location.hash.substring(1);
            filterValue = hashValue;
            uri = location.href;
            if (hashValue === 'all' || hashValue === '') {
                filterValue = '*';
            }
            if (hashValue === '') {
                uri = location.href + '#all';
            }
            if (!$filterButtons.filter('[href="'+uri+'"]').length) {
                return;
            }
            render();
        }

        function render() {
            matchCounter = 0;
            resetItemsHeight();
            isotope.arrange();
            $pagination.toggle( matchCounter > visibleItemsNum );
            $filterButtons.removeClass('active');
            $filterButtons.filter('[href="'+uri+'"]').addClass('active');
            $filterDropdown.find('option[value="'+uri+'"]').prop('selected', 'selected').trigger('change');
        }

        isotope = new Isotope(listSelector, {
            itemSelector: itemSelector,
            layoutMode: 'fitRows',
            filter: isotopeFilter,
            initLayout: false
        });
        isotope.on('layoutComplete', alignItemsHeight);
        handleFilters();
        $(window).on('hashchange', handleFilters);
        $pagination.on('click', 'button', showMoreItems);


        $listing.on('click', '.galleryTeaser', function () {
            let startIndex;
            const $this = $(this);
            let filteredElements;
            if (filterValue === '*') {
                filteredElements = $(itemSelector);
            } else {
                filteredElements = $(itemSelector + '.'+filterValue);
            }
            let popups = [];
            filteredElements.each(function (index, element) {
                popups.push({
                    src: $(element).find('.galleryTeaser').data('src'),
                    type: 'inline',
                });
                if ($(element).find('.galleryTeaser').data('src') === $this.data('src')) {
                    startIndex = index;
                }
            });
            Fancybox.show(popups, {
                dragToClose: false,
                startIndex: startIndex,
                Carousel: {
                    Thumbs: false,
                    Arrows: false,
                    /*gestures: function () {
                        return innerWidth < 1120;
                    },*/
                    transition: "slide",
                    breakpoints: {
                        "(min-width: 1120px)": {
                            transition: "fade",
                        }
                    }
                },
            })
        });
    });
});